var SelectionDirection;
(function (SelectionDirection) {
    // None
    SelectionDirection[SelectionDirection["None"] = 0] = "None";
    // Previous
    SelectionDirection[SelectionDirection["Previous"] = 1] = "Previous";
    // Next
    SelectionDirection[SelectionDirection["Next"] = 2] = "Next";
})(SelectionDirection || (SelectionDirection = {}));
export default SelectionDirection;
//# sourceMappingURL=SelectionDirection.js.map